import { createSlice } from "@reduxjs/toolkit";
import { factory } from "../../api/apiFactory";
import { showNotification } from "./notificationSlice";
import api from "../../api/apiConfig";

const settingsApi = factory.get("settings");

const initialState = {
  apk_latest_version: {
    loading: false,
    key: "",
    value: "",
    date: "",
    id: null,
  },
  apk_form: {
    loading: false,
    progress: 0,
    form: {
      key: "",
      value: "",
      file: "",
    },
  },
  finger_print_devices: {
    loading: false,
    data: [],
  },
};

export const settingsSlice = createSlice({
  name: "settings",
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state[action.payload].loading = !state[action.payload].loading;
    },
    setFingerPrintDevices: (state, { payload }) => {
      state.finger_print_devices.data = payload;
    },
    setLatestVersion: (state, { payload }) => {
      if (payload.length > 0) {
        const last_row = payload[payload.length - 1];
        state.apk_latest_version = {
          ...state.apk_latest_version,
          id: last_row.id,
          key: last_row.key,
          value: last_row.value,
          date: last_row.updated_at,
        };
      }
      state.apk_latest_version.loading = false;
    },
    setFiltersDialog: (state, action) => {
      state.apk_table.filters_dialog = !state.results.filters_dialog;
    },
    setFilters: (state, { payload }) => {
      state.apk_table.filters = {
        ...state.apk_table.filters,
        ...payload,
      };
    },
    resetFilters: (state) => {
      state.apk_table.filters = initialState.apk_table.filters;
    },
    setApkProgress: (state, { payload }) => {
      state.apk_form.progress = payload;
    },
    resetApkForm: (state) => {
      state.apk_form = initialState.apk_form;
    },
  },
});

export const {
  setLoading,
  setFilters,
  setLatestVersion,
  setFiltersDialog,
  resetFilters,
  setApkProgress,
  resetApkForm,
  setFingerPrintDevices,
} = settingsSlice.actions;

export default settingsSlice.reducer;

//axios
const getAll = () => async (dispatch, getState) => {
  try {
    dispatch(setLoading("apk_latest_version"));
    const res = await settingsApi.getAll();
    dispatch(setLatestVersion(res.data.data));
  } catch (err) {
    dispatch(setLoading("apk_latest_version"));
    throw new Error(err);
  }
};
const getFingerPrintDevices = () => async (dispatch) => {
  try {
    dispatch(setLoading("finger_print_devices"));
    const res = await settingsApi.getFingerPrintDevices();
    dispatch(setFingerPrintDevices(res.data.data));
    dispatch(setLoading("finger_print_devices"));
  } catch (err) {
    dispatch(setLoading("finger_print_devices"));
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};

const uploadApk = (data) => async (dispatch) => {
  try {
    dispatch(setLoading("apk_form"));
    let formData = new FormData();
    formData.append("file", data.file);

    await api.post(`/api/v1/upload-apk`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      onUploadProgress: (progressEvent) => {
        const { loaded, total } = progressEvent;
        const percent = Math.floor((loaded * 100) / total);
        dispatch(setApkProgress(percent));
      },
    });

    dispatch(setLoading("apk_form"));
    dispatch(
      showNotification({
        message: "تم رفع الملف بنجاح",
        type: "success",
      })
    );
    dispatch(resetApkForm());
    dispatch(getAll());
    return { status: true };
  } catch (err) {
    dispatch(setLoading("apk_form"));
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};

const update = (data) => async (dispatch) => {
  try {
    dispatch(setLoading("apk_form"));
    await settingsApi.update({
      id: 2,
      key: data.key,
      value: data.value,
    });

    dispatch(setLoading("apk_form"));
    dispatch(
      showNotification({
        message: "تم رفع الملف بنجاح",
        type: "success",
      })
    );
    dispatch(resetApkForm());
    dispatch(getAll());
    return { status: true };
  } catch (err) {
    dispatch(setLoading("apk_form"));
    dispatch(
      showNotification({
        message: err.response.data.errors[0],
        type: "error",
      })
    );
    throw new Error(err);
  }
};

export const Settings = {
  getAll,
  update,
  uploadApk,
  getFingerPrintDevices,
};
